import React from "react";
import styled from "styled-components";
import PretendardText from "../../component/atoms/text/pretendardText";

function Modal({ type, title, text, setModalOpen, onClick }) {
  return (
    <ModalWrapper>
      <ModalBox>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ModalTitle>{title}</ModalTitle>
          {text ? <ModalText>{text}</ModalText> : null}
        </div>
        <ModalBtnWrapper>
          {type !== "alert" && (
            <CancelBtn onClick={() => setModalOpen(false)}>취소</CancelBtn>
          )}
          <ModalBtn type={type} onClick={onClick}>
            확인
          </ModalBtn>
        </ModalBtnWrapper>
      </ModalBox>
    </ModalWrapper>
  );
}

export default Modal;

const ModalWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000060;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
`;

const ModalBox = styled.div.attrs((props) => {})`
  width: 394px;
  min-height: 173px;
  height: auto;
  padding: 40px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  border-radius: 15px;
  background: #272829;
  box-shadow: 0px 4px 20px 0px rgba(10, 13, 20, 0.15);
`;

const ModalTitle = styled(PretendardText).attrs((props) => {})`
  font-size: 22px;
  font-weight: 700;
  line-height: 33px;
  color: #f3f3f3;
  text-align: center;
`;

const ModalText = styled(PretendardText).attrs((props) => {})`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #aaa;
  text-align: center;
  margin-top: 6px;
`;

const ModalBtnWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`;

const CancelBtn = styled.button.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 5px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #aaa;
  background: #313233;
  font-family: "Pretendard";
  font-size: 15px;
  font-weight: 600;
  line-height: 24.5px;
  border-radius: 100px;
`;

const ModalBtn = styled.button.attrs((props) => {})`
  width: 76px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: ${(props) => (props.type === "negative" ? "#cf6679" : "#279eff")};
  font-family: "Pretendard";
  font-size: 15px;
  font-weight: 600;
  line-height: 24.5px;
  border-radius: 100px;
`;
